import React from 'react';
import { Helmet } from 'react-helmet';
import { googleAnalyticsID } from '../utils/env';

function HeaderTags() {
  return (
    <Helmet>
      <html lang="pt-br" />
      <meta name="robots" content="noindex, nofollow" />
      <script>
        {`
          (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
          })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
          ga('create', '${googleAnalyticsID}', 'auto');
          ga('send', 'pageview');
        `}
      </script>
    </Helmet>
  );
}

// Memoize component to render scripts and headers just once
export default React.memo(HeaderTags);
